import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import AvatarS1 from '../../../../inc/assets/images/portrait/small/avatar-s-1.png';
import KoochiLogo from '../../../../styles/images/koochi-logo.png';
import KoochiLogoWhite42 from '../../../../inc/assets/images/logo/sitag-logo-white-42.png';
import KoochiLogoWhite58 from '../../../../inc/assets/images/logo/sitag-logo-white-58.png';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { actionLogOutUser } from '../../../../redux/actions/pages/user/login';
import Swal from 'sweetalert2';
import axios from "axios";
import { BASE_SITE, LOGOUT_GET } from '../../../../apis'; 
import KoochiLogoWhite from '../../../../styles/images/sitag-logo-dark-white-final-125.png'; 






import * as React from 'react';
import { useRef, useEffect } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import PhoneIcon from '@mui/icons-material/Phone';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Logout } from "@mui/icons-material";
import Typography from '@mui/material/Typography';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import InventoryIcon from '@mui/icons-material/Inventory';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';

const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
    zIndex: '0',
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
    backgroundColor: '#0070eb',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
        {
            props: ({ open }) => open,
            style: {
                marginRight: drawerWidth,
                width: `calc(100% - ${drawerWidth}px)`,
                transition: theme.transitions.create(['width', 'margin'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
        },
    ],
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        variants: [
            {
                props: ({ open }) => open,
                style: {
                  ...openedMixin(theme),
                  '& .MuiDrawer-paper': openedMixin(theme),
                },
            },
            {
                props: ({ open }) => !open,
                style: {
                  ...closedMixin(theme),
                  '& .MuiDrawer-paper': closedMixin(theme),
                },
            },
        ],
    }),
);





const HeaderBase = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.login);

    const handleLogOut = () => {
        handleDrawerClose();

        const buttonsOkCancel = Swal.mixin({
            customClass: {
                confirmButton: 'btn  btn-outline-primary width-80 mr-2',
                cancelButton: 'btn grey btn-outline-secondary width-80',
            },
            buttonsStyling: false
        });

        buttonsOkCancel.fire({
            text: "آیا میخواهید از حساب کاربری خود خارج شوید؟",
            imageUrl: KoochiLogo,
            imageHeight: 60,
            imageAlt: 'کوچی',
            confirmButtonText: "بله",
            showCancelButton: true,
            cancelButtonText: 'انصراف',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(handleSetBackdropLoading(true));
                axios({
                    method: 'get',
                    url: BASE_SITE + LOGOUT_GET,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': token
                    },
                }).then((response) => {
                    switch (response.data.status) {
                        case 'error':
                            dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                            break;
                        case 'ok':
                            dispatch(actionLogOutUser());


                            navigate('../login');
                            break;
                        default:
                            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                    }
                    dispatch(handleSetBackdropLoading(false));
                }, () => {
                    dispatch(handleSetBackdropLoading(false));
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                });
            }
        }); 
    };





















    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    const drawerRef = useRef(null);

    // بستن دراور هنگام کلیک بیرون
    useEffect(() => {
        function handleClickOutside(event) {
            if (drawerRef.current && !drawerRef.current.contains(event.target)) {
                setOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };


    let menuItemText =  ['پروفایل', 'محصولات من', 'کل محصولات', 'سفارش ها'];
    let menuItemIcon = [<AccountCircleIcon />, <InventoryIcon />, <ViewModuleIcon />, <ShoppingBagIcon />];
    let menuItemLink = ['../profile', '../my-products', '../products', '/orders'];


    return (
        <>


        <nav className="header-navbar navbar navbar-with-menu navbar-fixed-top navbar-semi-dark navbar-shadow">
            <div className="navbar-wrapper">
                <div className="navbar-header">
                    <ul className="nav navbar-nav">
                        <li className="nav-item mobile-menu hidden-md-up float-xs-left">
                            <a className="nav-link nav-menu-main menu-toggle hidden-xs">
                                <i className="icon-menu5 font-large-1"></i>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a href="index.html" className="navbar-brand nav-link">
                                <img alt="branding logo" src={KoochiLogoWhite58} data-expand={KoochiLogoWhite58} data-collapse={KoochiLogoWhite42} className="brand-logo" />
                            </a>
                        </li>
                        <li className="nav-item hidden-md-up float-xs-right">
                            <a data-toggle="collapse" data-target="#navbar-mobile" className="nav-link open-navbar-container">
                                <i className="icon-ellipsis pe-2x icon-icon-rotate-right-right"></i>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="navbar-container content container-fluid" style={{backgroundColor: '#00093a'}} >
                    <div id="navbar-mobile" className="collapse navbar-toggleable-sm">
                        <ul className="nav navbar-nav">
                            <li className="nav-item hidden-sm-down">
                                <a className="nav-link nav-menu-main menu-toggle hidden-xs is-active">
                                    <i className="icon-menu5">         </i>
                                </a>
                            </li>
                        </ul>
                        <ul className="nav navbar-nav float-xs-right">
                            <li className="dropdown dropdown-user nav-item">
                                <a href="#" data-toggle="dropdown" className="dropdown-toggle nav-link dropdown-user-link">
                                    <span className="avatar avatar-online">
                                        <img src={AvatarS1} alt="avatar" />
                                        <i></i>
                                    </span>
                                    <span className="user-name">{profile.operator_name}</span>
                                </a>
                                <div className="dropdown-menu dropdown-menu-right">
                                    <a href="#!" onClick={handleLogOut} className="dropdown-item"><i className="icon-power3"></i> خروج</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>






        {/*<div data-scroll-to-active="true" className="main-menu menu-fixed menu-dark menu-accordion menu-shadow">
            <div className="main-menu-content">
                <ul id="main-menu-navigation" data-menu="menu-navigation" className="navigation navigation-main">

                    { profile.type === 'cashier' || profile.type === 'cashier_high' ?
                    <>
                    <li className="nav-item active"><Link to="../trans"><i className="icon-money"></i><span data-i18n="nav.form_layouts.form_layout_basic" className="menu-title">ریز تراکنش ها</span></Link>
                    </li>
                    <li className="nav-item "><Link to="../trans/add"><i className="icon-circle-plus"></i><span data-i18n="nav.form_layouts.form_layout_basic" className="menu-title">ثبت تراکنش</span></Link>
                    </li>
                    </>
                    :
                    <li className=" nav-item"><a href="#!"><i className="icon-money"></i><span data-i18n="nav.dash.main" className="menu-title">تراکنش ها</span></a>
                        <ul className="menu-content">
                            <li className=""><Link to="../trans" data-i18n="nav.dash.main" className="menu-item">ریز تراکنش ها</Link>
                            </li>
                            <li className=""><Link to="../accumulative" data-i18n="nav.dash.main" className="menu-item">تجمیعی</Link>
                            </li>
                        </ul>
                    </li>
                    }
                  
                    <li className="nav-item"><a href="#!" onClick={handleLogOut}><i className="icon-power3"></i><span data-i18n="nav.form_layouts.form_layout_basic" className="menu-title">خروج</span></a>
                    </li>

                </ul>
            </div>
        </div>*/}

        







        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar position="fixed" open={open}>
                <Toolbar>
                    <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            sx={[
                              {
                                marginLeft: 5,
                              },
                              open && { display: 'none' },
                            ]}
                        >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="span" sx={{ flexGrow: 1, textAlign: 'center'}}>
                        <img src={KoochiLogoWhite} alt="کوچی" height={35} />
                    </Typography>
                    <Typography variant="span" sx={{ display: 'flex', flexDirection: 'row-reverse'}}>
                        <PhoneIcon /><a href="tel:+989391019323" style={{color: 'white'}}>9323 101 0939</a>
                    </Typography>
                </Toolbar>
            </AppBar>
            <Drawer variant="permanent" anchor="right" open={open} ref={drawerRef}>
                <DrawerHeader>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </DrawerHeader>
                <Divider />
                <List>
                { menuItemText.map((text, index) => (
                    <ListItem key={text} disablePadding sx={{ display: 'block' }}>
                        <Link to={menuItemLink[index]}>
                            <ListItemButton
                                    sx={[
                                        {
                                            minHeight: 48,
                                            px: 2.5,
                                        },
                                        open
                                        ? {
                                            justifyContent: 'initial',
                                          }
                                        : {
                                            justifyContent: 'center',
                                          },
                                    ]}
                            >
                                <ListItemIcon
                                        sx={[
                                            {
                                              minWidth: 0,
                                              justifyContent: 'center',
                                            },
                                            open
                                              ? {
                                                  mr: 3,
                                                }
                                              : {
                                                  mr: 'auto',
                                                },
                                        ]}
                                >
                                {menuItemIcon[index]}
                                </ListItemIcon>
                                <ListItemText
                                    primary={text}
                                    sx={[
                                        open
                                        ? {
                                            opacity: 1,
                                        }
                                        : {
                                            opacity: 0,
                                        },
                                    ]}
                                />
                            </ListItemButton>
                        </Link>
                    </ListItem>
                ))}
                </List>
                <Divider />
                <List>
                    {['خروج'].map((text, index) => (
                    <ListItem key={text} disablePadding sx={{ display: 'block' }}>
                        <ListItemButton onClick={handleLogOut}
                            sx={[
                                {
                                    minHeight: 48,
                                    px: 2.5,
                                },
                                open
                                ? {
                                    justifyContent: 'initial',
                                  }
                                : {
                                    justifyContent: 'center',
                                  },
                            ]}
                        >
                            <ListItemIcon
                                sx={[
                                    {
                                        minWidth: 0,
                                        justifyContent: 'center',
                                    },
                                    open
                                    ?   {
                                            mr: 3,
                                        }
                                    :   {
                                            mr: 'auto',
                                        },
                                ]}
                            >
                            <Logout />
                            </ListItemIcon>
                            <ListItemText
                                primary={text}
                                sx={[
                                    open
                                    ? {
                                        opacity: 1,
                                    }
                                    : {
                                        opacity: 0,
                                    },
                                ]}
                            />
                        </ListItemButton>
                    </ListItem>
                    ))}
                </List>
            </Drawer>
        </Box>





        </>
    );
}

export default HeaderBase;
